var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdClose = function SvgAdClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ad-close_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 15,
    fill: "#00104A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.295 12.298 12 13.594l.384.35c.407.37.612.564 2.108 1.998 1.263 1.21 1.9 1.905 1.9 2.074 0 .2-1.756 1.973-4.006 4.043l-.383.352 1.294 1.294 1.294 1.293.724-.775c.991-1.06 3.431-3.5 3.571-3.57.097-.05.131-.049.228 0 .143.072 2.602 2.531 3.57 3.57l.724.777 1.296-1.295L26 22.411l-.177-.164c-1.73-1.597-4.155-4.015-4.198-4.186-.019-.075.006-.145.088-.258.157-.213 2.562-2.603 3.51-3.487l.776-.724-1.295-1.296L23.41 11l-.205.219c-.113.12-.834.873-1.603 1.674-1.509 1.57-2.475 2.499-2.6 2.499-.155 0-1.696-1.516-3.705-3.644a90.673 90.673 0 0 0-.579-.61l-.129-.135-1.294 1.295z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ad-close_svg__a",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6592_276145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6592_276145",
    result: "shape"
  })))));
};
export default SvgAdClose;